import { useRef, useContext, useEffect, useState } from 'react'
import useFetch from 'hooks/useFetch'
import { UserContext } from 'context/userContext'
import * as Sessions from 'components/Modal/Items'
import useStorage from 'hooks/useStorage'
import { hasAccess, moneyToNumber } from 'helper/utils'
import {
  Checkbox,
  DoclistHandle,
  Loading,
  ShowDetails,
  UsersTable,
} from 'components/index'
import { IObject } from 'interfaces'
import ModalHeader from 'pages/Clientes/Components/ModalHeader'
import User from 'pages/Clientes/Components/User'
import { Icon } from 'assets/index'
import { CheckboxesContainer, Container, ShowToolTipContainer } from './style'

const statusOptions = [
  {
    label: 'Em negociação',
    value: 0,
  },
  {
    label: 'Contrato solicitado',
    value: 1,
  },
  {
    label: 'Contrato em criação',
    value: 2,
  },
  {
    label: 'Contrato em negociação',
    value: 3,
  },
  {
    label: 'Aguardando assinatura',
    value: 4,
  },
  {
    label: 'Contrato assinado',
    value: 5,
  },
  {
    label: 'Aguardando pagamento',
    value: 6,
  },
  {
    label: 'Pagamento realizado',
    value: 7,
  },
]

export default function DetalhesFinanceiro() {
  const { selectedId, loading, setLoading } = useContext(UserContext)
  const [data, setData] = useState<any>({})
  const [showDetails, setShowDetails] = useState<boolean>(false)
  const api = useFetch(
    `/gestor/contract?id=${
      selectedId.current.id || selectedId.current.contractId
    }`
  )
  const [payManualCheck, setPayManualCheck] = useState<boolean>(false)
  const [payNow, setPayNow] = useState<boolean>(false)
  const [loadingP, setLoadingP] = useState<any>(false)
  const formdata = useRef<FormData>(new FormData())
  // const api = useFetch(`/token/${selectedCardId}`)
  // const [isNewFeatureChecked, setNewFeatureChecked] = useState(false) // Estado para o terceiro checkbox

  const fetchData = async () => {
    try {
      setLoading(true)
      const response = await api.fetch('get')
      if (response.fail) throw new Error(response.errors.message)
      const info = response.data.data
      const { enterpriseId } = info.token
      info.documentList = []
      switch (info.token.holderList.length) {
        case 0:
          info.capType = 'Aberta'
          break
        case 1:
          info.capType = 'Personalizada Individual'
          break
        default:
          info.capType = 'Personalizada em Grupo'
      }
      info.account = await api
        .fetch('get', null, `/gestor/account?id=${info.accountId}`)
        .then((r) => r.data.data)

      info.enterprise = await api
        .fetch('get', null, `/gestor/enterprise?id=${enterpriseId}`)
        .then((r) => r.data.data)

      info.attachment = { enterprise: [], contract: [] }

      // Enterprise
      ;['contract', 'enterprise'].forEach((s: string) => {
        ;['contract', 'document'].forEach((type: string) => {
          info[s][`${type}List`]?.forEach((c: IObject) => {
            info.attachment[s].push({
              name: c.type,
              file: c.file,
              type,
              status: c.status,
            })
          })
        })
      })

      // Atualiza a contagem da cota
      if ([4, 10, 11].includes(selectedId.current.columnId))
        info.contract.parcel -= 1

      info.token.contract = info.contract
      setData(info)
      setLoading(false)
    } catch (err: any) {
      console.error('err', err)
      setLoading(false)
    }
  }
  useEffect(() => {
    fetchData()
  }, [])

  const handleUpdate = (status: string, endpoint: any) => {
    return new Promise((resolve) => {
      api
        .fetch(
          'put',
          { status },
          endpoint
          // `/gestor/kanban/payments/${selectedId.current.id}`
          // `/gestor/kanban/contract/${card.id}`
        )
        .then(resolve)
        .catch((err) => {
          console.error(err)
        })
    })
  }

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       setLoading(true)
  //       const response: IResponse = await api.fetch('get')
  //       if (response.fail) throw new Error(response.errors.message)
  //       setData(response.data.data)
  //       setLoading(false)
  //     } catch (err: any) {
  //       console.log('err', err)
  //       setLoading(false)
  //     }
  //   }

  //   fetchData()
  // }, [])
  const invested: any = moneyToNumber(data?.contract?.invested)

  if (loading) return <Loading modal />
  return (
    <Container>
      <ModalHeader
        user={data?.account?.user}
        title={data?.token?.name}
        type={data?.capType}
        subtitle="Detalhes da captação"
        status={data?.contract?.status}
        statusOptions={statusOptions}
        tokenGestorId={data?.token?.gestorId}
        gestorId={data?.account?.account?.gestorId}
      />

      <div>
        <ShowDetails
          onClick={() => setShowDetails((oldValue) => !oldValue)}
          hidden={!showDetails}
        />
        {showDetails ? <User accountData={data} readonly /> : null}
      </div>
      <Sessions.Info token={data?.token} />
      <Sessions.Condition
        setData={setData}
        contractId={selectedId.current.id || selectedId.current.contractId}
        notClickable={selectedId?.current?.columnId !== 10}
        token={data?.token}
        contract={data?.contract}
        enterprise={data?.enterprise}
      />
      <Sessions.Contract token={data?.token} contract={data?.contract} />
      <Sessions.Rental token={data?.token} />
      <Sessions.Dates
        edit={
          hasAccess('edit-dates-financial') &&
          (selectedId?.current?.columnId === 10 ||
            selectedId?.current?.columnId === 11)
        }
        isInvesment={invested > 0}
        token={data.token}
        data={data}
        setData={setData}
        contractId={selectedId.current.id || selectedId.current.contractId}
      />
      {data?.bonus && <Sessions.Bonus data={data?.bonus} />}
      <Sessions.Payments token={data?.token} />

      <CheckboxesContainer>
        <ShowToolTipContainer>
          <div className="tooltip">
            <span className="tooltip-txt">Selecione quando houver</span>
            <span className="tooltip-txt bold">
              problemas no pagamento do cliente
            </span>
          </div>

          <Checkbox
            disabled={!hasAccess('checkbox-analisePagamento-financial')}
            loading={loadingP === 'analyzePayment'}
            label="Analisar Pagamento"
            setChecked={(state) => {
              setLoadingP('analyzePayment')
              api
                .fetch(
                  'put',
                  { status: state ? -5 : 11 },
                  `/gestor/kanban/payments/${
                    selectedId.current.id || selectedId.current.contractId
                  }`
                )
                .then((res) => {
                  if (res.fail) return setLoadingP(false)
                  setData((old: any) => ({
                    ...old,
                    isStuck: state,
                  }))
                  setLoadingP(false)
                })
                .catch((err) => {
                  console.error(err)
                })
            }}
            checked={data?.isStuck}
          />
          <img src={Icon('alert_circle.svg')} alt="alert" className="icon" />
        </ShowToolTipContainer>

        <ShowToolTipContainer>
          <Checkbox
            disabled={!hasAccess('checkbox-analiseContrato-financial')}
            loading={loadingP === 'analyzeContract'}
            label="Analisar Contrato"
            setChecked={(state) => {
              setLoadingP('analyzeContract')
              api
                .fetch(
                  'put',
                  { status: state ? -8 : 11 },
                  `/gestor/kanban/contract/${
                    selectedId.current.id || selectedId.current.contractId
                  }`
                )
                .then((res) => {
                  if (res.fail) return setLoadingP(false)
                  setData((old: any) => ({
                    ...old,
                    contract: {
                      ...old.contract,
                      isStuck: state,
                    },
                  }))
                  setLoadingP(false)
                })
                .catch((err) => {
                  console.error(err)
                })
            }}
            checked={data?.contract?.isStuck}
          />
          <img src={Icon('alert_circle.svg')} alt="alert" className="icon" />
          <div className="tooltip">
            <span className="tooltip-txt">Selecione quando houver</span>
            <span className="tooltip-txt bold">
              problemas no contrato do cliente
            </span>
          </div>
        </ShowToolTipContainer>

        {![10, 11, 4].includes(selectedId?.current?.columnId) && (
          <ShowToolTipContainer>
            <Checkbox
              disabled={
                !hasAccess('checkbox-pagamentoManual-financial') ||
                payManualCheck
              }
              loading={loadingP === 'manualPay'}
              label="Pagamento Manual"
              setChecked={(_) => {
                setLoadingP('manualPay')
                api
                  .fetch(
                    'put',
                    null,
                    `/gestor/purchase/${
                      selectedId.current.id || selectedId.current.contractId
                    }/force-pay-rentability`
                  )
                  .then((res) => {
                    if (res.fail) return setLoadingP(false)
                    setPayManualCheck(true)
                    setLoadingP(false)
                  })
                  .catch((err) => {
                    console.error(err)
                    setLoadingP(false)
                  })
              }}
              checked={payManualCheck}
            />
            <img src={Icon('alert_circle.svg')} alt="alert" className="icon" />
            <div className="tooltip">
              <span className="tooltip-txt">Selecione quando foi feito</span>
              <span className="tooltip-txt bold">
                o pagamento externo da parcela.
              </span>
            </div>
          </ShowToolTipContainer>
        )}

        {[0].includes(selectedId?.current?.columnId) && (
          <ShowToolTipContainer>
            <Checkbox
              disabled={
                !hasAccess('checkbox-payNow-financial') ||
                payNow ||
                data?.isStuck
              }
              loading={loadingP === 'payNow'}
              label="Pagar Agora"
              setChecked={(_) => {
                setLoadingP('payNow')
                api
                  .fetch(
                    'put',
                    { status: 0 },
                    `/gestor/kanban/payments/${
                      selectedId.current.id || selectedId.current.contractId
                    }`
                  )
                  .then((res) => {
                    if (res.fail) return setLoadingP(false)
                    setPayNow(true)
                    setLoadingP(false)
                  })
                  .catch((err) => {
                    console.error(err)
                    setLoadingP(false)
                  })
              }}
              checked={payNow}
            />
            <img src={Icon('alert_circle.svg')} alt="alert" className="icon" />
            <div className="tooltip">
              <span className="tooltip-txt">Selecione para realizar</span>
              <span className="tooltip-txt bold">o pagamento agora.</span>
            </div>
          </ShowToolTipContainer>
        )}

        {/* Terceiro Checkbox */}
        {/* <ShowToolTipContainer>
          <Checkbox
            disabled={user?.permission === 'READ'}
            loading={loadingP === 'analyzeNewFeature'}
            label="Aprovar resgate do principal"
            setChecked={(state) => {
              setLoadingP('analyzeNewFeature')
              api
                .fetch(
                  'put',
                  { status: state ? -10 : 11 },
                  `/xablau/${selectedId.current.id}`
                )
                .then((res) => {
                  if (res.fail) return setLoadingP(false)
                  setNewFeatureChecked(state)
                  setLoadingP(false)
                })
                .catch((err) => {
                  setLoadingP(false)
                })
            }}
            checked={isNewFeatureChecked}
          />
          <img src={Icon('alert_circle.svg')} alt="alert" className="icon" />
          <div className="tooltip">
            <span className="tooltip-txt">Após aprovação do resgate o</span>
            <span className="tooltip-txt bold">
              sistema para de pagar rentabilidade
            </span>
          </div>
        </ShowToolTipContainer> */}
      </CheckboxesContainer>

      {data?.token?.holderList?.length > 1 && (
        <UsersTable
          captationID="id"
          data={data?.token?.holderList}
          disableDelete
        />
      )}
      <h4 className="detalhes-captacao-subtitle">Anexos da captação</h4>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          readonly
          documentList={data?.attachment?.contract}
          formdata={formdata.current}
        />
      </div>
      <div className="detalhes-botoes-container">
        <DoclistHandle
          documentList={data?.attachment?.enterprise}
          readonly
          formdata={formdata.current}
        />
      </div>
    </Container>
  )
}
